'use strict';

namespace CMS {

    interface AdvisoryBannerItem {
        id: string;
        title: string;
        body: string;
        linkText: string;
        linkUrl: string;
    }

    class AdvisoryBannerController {

        itemsJson: string;
        autoplay: boolean;
        autoplaySpeed: number;
        items: AdvisoryBannerItem[] = [];

        $onInit(): void {
            this.items = this.parseItems(this.itemsJson);
        }

        private parseItems(itemsJson: string): AdvisoryBannerItem[] {
            if (!itemsJson) {
                return [];
            }

            try {
                const items = JSON.parse(itemsJson);

                return angular.isArray(items)
                    ? items
                    : [];
            } catch (error) {
                return [];
            }
        }
    }

    angular
        .module('cms')
        .component('advisoryBanner', {
            bindings: {
                itemsJson: '@',
                autoplay: '<',
                autoplaySpeed: '<'
            },
            controller: AdvisoryBannerController,
            template: `
                <announcement-rotator
                    items="$ctrl.items"
                    autoplay="$ctrl.autoplay"
                    autoplay-duration="$ctrl.autoplaySpeed">
                </announcement-rotator>
            `
        });
}
